export default __webpack_public_path__ + "images/codey-right.png";